import type { AppDispatch, RootState } from '../storeConfig/store';
import { selectFormByFormId, selectSectionStatus, updateForm } from '../slices';
import { selectAppliciableSection } from '../slices/sustainability-forms.slice';
import {
	SustainabilityFormAnswerSectionDto,
	SustainabilitySections
} from '../../models/sustainability';

export const CERTIFICATIONS_SECTION_NAME =
	SustainabilitySections[SustainabilitySections.Certifications];

type ProfileReducerState = { profile?: { id?: number | string; type?: number } };

export function getProfileTypeFromState(state: RootState, profileId: number): number | null {
	const profile = (state.profileReducer as ProfileReducerState | undefined)?.profile;
	if (!profile) return null;

	const id = Number(profile.id);
	if (Number.isNaN(id) || id !== profileId) return null;

	const type = profile.type;
	return type !== null && type !== undefined ? Number(type) : null;
}

export function syncFormAnswerSectionStatus(
	dispatch: AppDispatch,
	state: RootState,
	profileId: number,
	formId: number,
	profileType: number,
	section: string
): void {
	const status = selectSectionStatus(state, profileId, formId, profileType, section);
	const isApplicable = selectAppliciableSection(state, profileId, formId, section);
	const form = selectFormByFormId(state, profileId, formId);

	if (!form) return;

	const answeredSection: SustainabilityFormAnswerSectionDto = {
		section,
		status,
		isApplicable
	};
	const existingSections = form.answerSections ?? [];
	const sectionIndex = existingSections.findIndex((s) => s.section === section);

	const newAnswerSections =
		sectionIndex >= 0
			? existingSections.map((s, i) => (i === sectionIndex ? answeredSection : s))
			: [...existingSections, answeredSection];

	dispatch(updateForm({ form: { ...form, answerSections: newAnswerSections } }));
}

export function syncCertificationsSectionStatus(
	dispatch: AppDispatch,
	getState: () => RootState,
	profileId: number,
	formId: number
): void {
	const state = getState();
	const profileType = getProfileTypeFromState(state, profileId);
	if (profileType === null) return;

	syncFormAnswerSectionStatus(
		dispatch,
		state,
		profileId,
		formId,
		profileType,
		CERTIFICATIONS_SECTION_NAME
	);
}
